import Nav from "./../components/navbar/navbar";
// import Header from "./../components/aboutcomponents/header";
// import Team from "./../components/aboutcomponents/team";
import Choose from "./../components/aboutcomponents/whychoose";
import Footer from "./../components/footer/footer";
import Review from "./../components/aboutcomponents/review";
import History from "./../components/aboutcomponents/history";
import Ex from "./../components/aboutcomponents/exhead";
import Briefhistory from "./../components/aboutcomponents/briefhistory";
import Principle from "./../components/servicecomponent/principle";
import Newteam from "./../components/aboutcomponents/newteam";
import Newsletter from "./../components/homecomponents/newsletter1";

const About = () => {
    return(
    <div>
        <Nav/>
        <Ex/>
        {/* <Header/> */}
        <Briefhistory/>
        <History/>
        {/* <Team/> */}
        <Newteam/>
        <Choose/>
        
        <Review/>
        <Principle/>
        <Newsletter/>
        <Footer/>
    </div>
    )
}
export default About;